import { z } from 'zod';
import { passwordSchema } from '../auth/schemas.js';
export const TENANT_STATUSES = ['active', 'suspended', 'archived'];
const hexColor = z.string().regex(/^#[0-9a-fA-F]{6}$/, 'Use a #RRGGBB colour');
export const tenantSlugSchema = z
    .string()
    .trim()
    .toLowerCase()
    .regex(/^[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?$/, 'Lowercase letters, numbers and hyphens only');
export const brandingSchema = z.object({
    displayName: z.string().trim().min(1).max(80).optional(),
    logoUrl: z.url().nullish(),
    primaryColor: hexColor.optional(),
    accentColor: hexColor.optional(),
});
export const tenantSettingsSchema = z.object({
    timezone: z.string().default('Asia/Kolkata'),
    locale: z.string().default('en-IN'),
    currency: z.string().length(3).default('INR'),
});
export const createTenantSchema = z.object({
    slug: tenantSlugSchema,
    name: z.string().trim().min(2).max(120),
    planCode: z.string().trim().min(2),
    branding: brandingSchema.default({}),
    settings: tenantSettingsSchema.default({ timezone: 'Asia/Kolkata', locale: 'en-IN', currency: 'INR' }),
    admin: z.object({
        name: z.string().trim().min(2).max(120),
        email: z.string().trim().toLowerCase().pipe(z.email()),
        password: passwordSchema,
    }),
});
export const updateTenantSchema = z
    .object({
    name: z.string().trim().min(2).max(120),
    status: z.enum(TENANT_STATUSES),
    planCode: z.string().trim().min(2),
    branding: brandingSchema,
    settings: tenantSettingsSchema.partial(),
})
    .partial()
    .refine((v) => Object.keys(v).length > 0, 'Nothing to update');
export const setModuleSchema = z.object({ enabled: z.boolean() });
//# sourceMappingURL=schemas.js.map